import React from "react";
import * as S from "./styles.ts";
import NewLogin from "../../../components/NewLogin/index.tsx";

const LoginPage: React.FC = () => {
  return (
    <S.Container>
      <NewLogin />
    </S.Container>
  );
};

export default LoginPage;
